var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1327 16L16 28.8513",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21.9165V10.0835C27.5 9.90638 27.453 9.73246 27.3637 9.57951C27.2745 9.42655 27.1462 9.30004 26.9921 9.2129L16.4921 3.27812C16.3419 3.19327 16.1724 3.14868 16 3.14868C15.8276 3.14868 15.6581 3.19327 15.5079 3.27812L5.00794 9.2129C4.85378 9.30004 4.72551 9.42655 4.63627 9.57951C4.54703 9.73246 4.5 9.90638 4.5 10.0835V21.9165C4.5 22.0936 4.54703 22.2675 4.63627 22.4205C4.72551 22.5734 4.85378 22.7 5.00794 22.7871L15.5079 28.7219C15.6581 28.8067 15.8276 28.8513 16 28.8513C16.1724 28.8513 16.3419 28.8067 16.4921 28.7219L26.9921 22.7871C27.1462 22.7 27.2745 22.5734 27.3637 22.4205C27.453 22.2675 27.5 22.0936 27.5 21.9165V21.9165Z",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3628 9.57837L16.1326 16L4.6377 9.577",
    stroke: "#0079C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/Cube.c2e7ad364563c4e7813251406ea6265b.svg";
export { ForwardRef as ReactComponent };